<div class="enf-root">
  <!-- Los encabezados de la tabla no dependen del libro: se declaran una vez y los usan la tabla real
       y su esqueleto, así las columnas ya están en su sitio antes de que lleguen los datos. -->
  <ng-template #cabeceraPeriodos>
    <tr>
      <th class="enf-col-exp"></th>
      <th class="text-center">#</th>
      <th class="text-center">Fecha</th>
      <th class="text-center">Capital</th>
      <th class="text-center">Interés</th>
      <th class="text-center">Accesorios</th>
      <th class="text-center">Comisión Acc.</th>
      <th class="text-center">Mora</th>
      <th class="text-center">IVA</th>
      <th class="text-center">Pago Esperado</th>
      <th class="text-center">Pago Aplicado</th>
      <th class="text-center">Pago Pendiente</th>
      <th class="text-center">Capital Pendiente</th>
      <th class="text-center">Días Atraso</th>
      <th class="text-center">Mora Diaria</th>
      <th class="text-center">Estado</th>
      <th class="text-center">Factura</th>
    </tr>
  </ng-template>

  <!-- Carga: la misma tarjeta que va a aparecer, en gris. Un spinner centrado no dice nada de lo que
       viene; esto ya enseña la franja, la banda, la barra de herramientas y las columnas de la tabla. -->
  <div
    class="enf-skeleton"
    *ngIf="ledgerService.loading && !ledger"
    aria-busy="true"
    aria-label="Cargando el libro mayor del arrendamiento"
  >
    <div class="info-card wide-card">
      <div class="card-header">
        <i class="pi pi-table text-purple-600"></i>
        <h3>Períodos de Exigibilidad</h3>
        <div class="header-tags">
          <p-skeleton height="1.5rem" width="6rem" borderRadius="6px"></p-skeleton>
          <p-skeleton *ngFor="let b of [1, 2, 3]" height="2rem" width="9rem" borderRadius="6px"></p-skeleton>
        </div>
      </div>

      <div class="enf-metrics">
        <app-ledger-strip [loading]="true"></app-ledger-strip>
      </div>

      <div class="enf-toolbar">
        <p-skeleton height="2.1rem" width="13rem" borderRadius="6px"></p-skeleton>
        <div class="enf-chips">
          <p-skeleton
            *ngFor="let c of ['4.5rem', '6.5rem', '9rem', '7rem', '8.5rem']"
            height="1.75rem"
            [width]="c"
            borderRadius="999px"
          ></p-skeleton>
        </div>
        <p-skeleton height="2.35rem" width="16rem" borderRadius="6px" class="enf-sk-search"></p-skeleton>
      </div>

      <div class="card-content">
        <div class="table-container">
          <p-table [value]="skeletonRows" [scrollable]="true" scrollHeight="560px" styleClass="p-datatable-sm amortization-table">
            <ng-template pTemplate="header"><ng-container *ngTemplateOutlet="cabeceraPeriodos"></ng-container></ng-template>
            <ng-template pTemplate="body" let-fila>
              <!-- La opacidad decrece hacia abajo: sugiere que la tabla sigue sin fingir cuántas letras trae. -->
              <tr [ngClass]="'sk-fade-' + (fila > 4 ? 4 : fila)">
                <td class="enf-col-exp"><p-skeleton width="1.6rem" height="1.6rem" borderRadius="6px"></p-skeleton></td>
                <td><p-skeleton height="0.8rem" width="1.2rem"></p-skeleton></td>
                <td><p-skeleton height="0.8rem" width="5rem"></p-skeleton></td>
                <td *ngFor="let c of [1, 2, 3, 4, 5, 6]"><p-skeleton height="0.8rem" width="4.5rem"></p-skeleton></td>
                <td *ngFor="let c of [1, 2, 3]"><p-skeleton height="0.8rem" width="5rem"></p-skeleton></td>
                <td><p-skeleton height="0.8rem" width="2rem"></p-skeleton></td>
                <td><p-skeleton height="0.8rem" width="4rem"></p-skeleton></td>
                <td><p-skeleton height="1.4rem" width="5rem" borderRadius="6px"></p-skeleton></td>
                <td><p-skeleton height="1.6rem" width="6rem" borderRadius="6px"></p-skeleton></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>

  <!-- Error -->
  <div class="no-data-container" *ngIf="ledgerService.error as err">
    <div class="no-data-card">
      <i class="pi pi-exclamation-triangle"></i>
      <h3>No se pudo leer el libro mayor</h3>
      <p>{{ err }}</p>
      <button
        pButton
        type="button"
        label="Reintentar"
        icon="pi pi-refresh"
        class="p-button-outlined p-button-sm"
        (click)="ledgerService.refresh()"
      ></button>
    </div>
  </div>

  <!-- Vacío: el arrendamiento no tiene tabla de amortización -->
  <div class="no-data-container" *ngIf="ledger && !ledger.periods.length">
    <div class="no-data-card">
      <i class="pi pi-info-circle"></i>
      <h3>No hay término de cotización aprobado</h3>
      <p>Por favor selecciona el término de la cotización aprobado por el cliente para visualizar este apartado.</p>
    </div>
  </div>

  <ng-container *ngIf="ledger && ledger.periods.length">
    <div class="info-card wide-card">
      <div class="card-header">
        <i class="pi pi-table text-purple-600"></i>
        <h3>Períodos de Exigibilidad</h3>
        <div class="header-tags">
          <p-tag [value]="ledger.periods.length + ' períodos'" severity="info"></p-tag>
          <!-- Sin gate: todos leen. Es la salida para lo que no pasa por la pestaña (un pago aplicado desde la app) -->
          <button
            pButton
            type="button"
            label="Actualizar"
            icon="pi pi-refresh"
            class="p-button-sm p-button-text"
            [loading]="ledgerService.loading"
            (click)="ledgerService.refresh()"
          ></button>
          <button
            *appIfHasPermission="['payments', 'create']"
            pButton
            type="button"
            label="Registrar pago"
            icon="pi pi-plus"
            class="p-button-sm p-button-outlined"
            (click)="openRegister()"
          ></button>
          <button
            *appIfHasPermission="['leases', 'update']"
            pButton
            type="button"
            label="Editar fecha de inicio"
            icon="pi pi-calendar"
            class="p-button-sm p-button-outlined"
            (click)="openEditStartDate()"
          ></button>
          <button
            *appIfHasPermission="['leases', 'edit-amounts']"
            pButton
            type="button"
            label="Editar saldos"
            icon="fa-solid fa-money-bill-trend-up"
            class="p-button-sm p-button-outlined"
            (click)="openAmountsEditor()"
          ></button>
        </div>
      </div>

      <!-- Franja de estado y comportamiento DENTRO de la tarjeta: son el encabezado de lo que la
           tabla detalla, no bloques sueltos que compiten con ella. -->
      <div class="enf-metrics">
        <app-ledger-strip
          [totals]="ledger.totals"
          [quality]="ledger.quality"
          [periods]="ledger.periods"
          [unapplied]="ledger.unapplied"
          [moraPaused]="moraPaused"
          (apply)="openApply(ledger.unapplied)"
          (residual)="openResidual(ledger.unapplied)"
        ></app-ledger-strip>
      </div>

      <!-- Barra de herramientas: vista · filtros con su conteo · búsqueda a la derecha -->
      <div class="enf-toolbar">
        <p-selectButton
          styleClass="enf-seg"
          [options]="viewOptions"
          [(ngModel)]="view"
          [allowEmpty]="false"
          optionLabel="label"
          optionValue="value"
        ></p-selectButton>
        <div class="enf-chips" *ngIf="view === 'periods'">
          <!-- El conteo va en el propio filtro: saber cuántas letras hay detrás evita abrirlo para averiguarlo. -->
          <button
            *ngFor="let f of filters"
            type="button"
            class="enf-chip-filter"
            [class.is-on]="filter === f.key"
            [attr.aria-pressed]="filter === f.key"
            (click)="setFilter(f.key)"
          >
            {{ f.label }}<span class="enf-chip-n" *ngIf="f.key !== 'all'">{{ filterCounts[f.key] }}</span>
          </button>
        </div>
        <span class="p-input-icon-left enf-search">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [(ngModel)]="search" (ngModelChange)="onSearch()" placeholder="Clave de rastreo o folio fiscal" />
        </span>
      </div>

      <div class="card-content">
        <!-- Vista Por pago -->
        <app-payments-view
          *ngIf="view === 'payments'"
          [payments]="visiblePayments"
          [twinsById]="twinsById"
          (openPayment)="openPayment($event)"
          (apply)="openApply([$event])"
        ></app-payments-view>

        <!-- Vista Por periodo -->
        <div class="table-container" *ngIf="view === 'periods'">
          <p-table
            [value]="visiblePeriods"
            dataKey="_id"
            [expandedRowKeys]="expandedRowKeys"
            rowExpandMode="multiple"
            [scrollable]="true"
            scrollHeight="560px"
            styleClass="p-datatable-sm amortization-table"
          >
            <ng-template pTemplate="header"><ng-container *ngTemplateOutlet="cabeceraPeriodos"></ng-container></ng-template>
            <ng-template pTemplate="body" let-period let-expanded="expanded">
              <tr [class.enf-row-expanded]="expanded" [class.enf-row-future]="isFuture(period)">
                <td class="enf-col-exp">
                  <button
                    type="button"
                    class="enf-exp"
                    [class.is-open]="expanded"
                    [pRowToggler]="period"
                    [attr.aria-expanded]="expanded"
                    [attr.aria-label]="'Detalle de la letra ' + period.n"
                  >
                    <i class="pi pi-chevron-right"></i>
                  </button>
                </td>
                <td class="text-center enf-cell-n">{{ period.n }}</td>
                <td class="text-center">{{ period.date | date: 'dd/MM/yyyy' : 'UTC' }}</td>
                <td class="text-right">{{ period.nominal.capital | currency }}</td>
                <td class="text-right">{{ period.nominal.interest | currency }}</td>
                <td class="text-right">{{ period.nominal.accessoriesAmount | currency }}</td>
                <td class="text-right">{{ period.nominal.accessoriesInterest | currency }}</td>
                <td class="text-right">
                  <span
                    class="enf-waived"
                    *ngIf="period.mora.waived > 0"
                    pTooltip="Mora devengada antes de condonar"
                    tooltipPosition="top"
                    >{{ period.mora.accrued | currency }}</span
                  >{{ (period.mora.waived > 0 ? period.mora.exigible : period.mora.accrued) | currency }}
                  <i
                    *ngIf="moraPaused && period.mora.accrued > 0"
                    class="pi pi-pause text-color-secondary ml-1"
                    pTooltip="Mora en pausa: no entra al pendiente hasta encender el interruptor"
                    tooltipPosition="top"
                  ></i>
                </td>
                <td class="text-right">{{ period.nominal.inputIva | currency }}</td>
                <td class="text-right font-bold">{{ period.nominal.rent | currency }}</td>
                <td class="text-right font-bold">
                  {{ period.applied.total | currency }}
                  <span class="enf-pill is-info" *ngIf="appliedCount(period) > 1">{{ appliedCount(period) }} pagos</span>
                  <span
                    class="enf-pill is-warn"
                    *ngIf="(period.registrationLagDays || 0) >= 3"
                    [pTooltip]="'Se registró ' + period.registrationLagDays + ' días después de que el cliente pagó'"
                    tooltipPosition="top"
                    >+{{ period.registrationLagDays }} d</span
                  >
                </td>
                <!--
                  Lo que falta por pagar de la letra, DERIVADO del libro: exigible − aplicado, con la mora
                  dentro. Antes salía de `period.payment`, el pendiente que el motor mantenía a mano; cuando
                  los dos no coinciden es un desfase real y la fila lo dice con su chip (F5), en vez de
                  esconderlo detrás del campo almacenado.
                -->
                <td class="text-right font-bold">{{ period.pending | currency }}</td>
                <td class="text-right">{{ period.outstandingBalance | currency }}</td>
                <td class="text-center">{{ daysLate(period) }}</td>
                <td class="text-right">{{ period.mora.daily | currency }}</td>
                <td class="text-center">
                  <p-tag
                    [value]="statusLabels[period.view] || period.view"
                    [severity]="viewSeverity(period.view)"
                    [icon]="period.view === 'MORA_PENDING' ? 'pi pi-clock' : period.view === 'ANTICIPATED' ? 'pi pi-forward' : undefined"
                  >
                  </p-tag>
                  <!-- tabindex + aria-label: el chip informativo debe llegar por teclado, no solo por tooltip -->
                  <span class="enf-sub-note" *ngIf="statusNote(period) as nota">{{ nota }}</span>
                  <span
                    *ngIf="period.drift.paidWithBalance"
                    class="enf-chip is-danger enf-chip-block"
                    tabindex="0"
                    aria-label="Marcada pagada con saldo: el motor la cobrará por saldo real"
                    pTooltip="Marcada pagada con saldo: el motor la cobrará por saldo real"
                    tooltipPosition="top"
                    >pagada con saldo</span
                  >
                  <app-written-off-chip [amount]="period.residualWrittenOff"></app-written-off-chip>
                </td>
                <td class="text-center">
                  <div class="rf-invoice-actions">
                    <ng-container *ngIf="invoiceFor(period) as inv; else dashTpl">
                      <!-- LINKED (con CFDI): descargar + refacturar + cancelar -->
                      <ng-container *ngIf="inv.status !== 'PENDING_FILES'">
                        <span class="rf-tip" [pTooltip]="inv.pdfUrl ? 'Descargar PDF' : 'Sin PDF cargado'" tooltipPosition="top">
                          <button
                            pButton
                            type="button"
                            class="p-button-text p-button-danger rf-file-btn"
                            icon="fa-solid fa-file-pdf"
                            [disabled]="!inv.pdfUrl || isDownloading(period, 'pdf')"
                            (click)="downloadInvoiceFile(period, 'pdf')"
                          ></button>
                        </span>
                        <span class="rf-tip" [pTooltip]="inv.xmlUrl ? 'Descargar XML' : 'Sin XML cargado'" tooltipPosition="top">
                          <button
                            pButton
                            type="button"
                            class="p-button-text p-button-info rf-file-btn"
                            icon="fa-solid fa-file-code"
                            [disabled]="!inv.xmlUrl || isDownloading(period, 'xml')"
                            (click)="downloadInvoiceFile(period, 'xml')"
                          ></button>
                        </span>
                        <ng-container *appIfHasPermission="['invoices', 'update']">
                          <span class="rf-tip" pTooltip="Refacturar" tooltipPosition="top">
                            <button
                              pButton
                              type="button"
                              class="p-button-text p-button-warning rf-file-btn"
                              icon="fa-solid fa-rotate"
                              (click)="openRefacturar(period)"
                            ></button>
                          </span>
                          <span class="rf-tip" pTooltip="Cancelar factura" tooltipPosition="top">
                            <button
                              pButton
                              type="button"
                              class="p-button-text p-button-danger rf-file-btn"
                              icon="fa-solid fa-ban"
                              (click)="openCancel(period)"
                            ></button>
                          </span>
                        </ng-container>
                        <!-- Complemento de pago (REP): solo facturas PPD. Verde = recibido; ámbar = pendiente. -->
                        <ng-container *appIfHasPermission="['invoices', 'view']">
                          <span
                            *ngIf="inv.paymentType === 'PPD'"
                            class="rf-tip"
                            [pTooltip]="
                              inv.complementStatus === 'RECEIVED'
                                ? 'Ver / descargar complemento de pago (REP)'
                                : 'Complemento de pago pendiente — ver o subir el REP'
                            "
                            tooltipPosition="top"
                          >
                            <button
                              pButton
                              type="button"
                              class="p-button-text rf-file-btn"
                              [ngClass]="inv.complementStatus === 'RECEIVED' ? 'p-button-success' : 'p-button-warning'"
                              icon="fa-solid fa-receipt"
                              (click)="openComplements(period)"
                            ></button>
                          </span>
                        </ng-container>
                      </ng-container>
                      <!-- PENDING (referencia sin archivos): cargar para completarla -->
                      <ng-container *ngIf="inv.status === 'PENDING_FILES'">
                        <span
                          *ngIf="canUploadInvoice; else pendingTag"
                          class="rf-tip"
                          pTooltip="Cargar archivos (completar la factura pendiente)"
                          tooltipPosition="top"
                        >
                          <button
                            pButton
                            type="button"
                            class="p-button-text p-button-info rf-file-btn"
                            icon="fa-solid fa-cloud-arrow-up"
                            (click)="openUpload(period)"
                          ></button>
                        </span>
                        <ng-template #pendingTag><span class="text-color-secondary">Pendiente</span></ng-template>
                      </ng-container>
                    </ng-container>
                    <ng-template #dashTpl>
                      <button
                        *ngIf="canUploadInvoice"
                        pButton
                        type="button"
                        class="p-button-text p-button-info rf-file-btn"
                        icon="fa-solid fa-cloud-arrow-up"
                        pTooltip="Cargar factura (PDF/XML)"
                        tooltipPosition="top"
                        (click)="openUpload(period)"
                      ></button>
                      <span *ngIf="!canUploadInvoice && !hasCancelledHistory(period)" class="text-color-secondary">—</span>
                    </ng-template>
                    <!-- Historial: solo si el periodo tiene facturas canceladas/reemplazadas -->
                    <span
                      *ngIf="hasCancelledHistory(period)"
                      class="rf-tip"
                      pTooltip="Historial de facturas del periodo"
                      tooltipPosition="top"
                    >
                      <button
                        pButton
                        type="button"
                        class="p-button-text p-button-secondary rf-file-btn"
                        icon="fa-solid fa-clock-rotate-left"
                        (click)="openHistory(period)"
                      ></button>
                    </span>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-period>
              <tr class="enf-row-detail">
                <td colspan="17">
                  <app-period-detail
                    [period]="period"
                    [isNextToCollect]="ledger!.nextToCollect === period.n"
                    [unapplied]="ledger!.unapplied"
                    (openPayment)="openPayment($event)"
                    (apply)="openApply(ledger!.unapplied)"
                    (waive)="openWaive($event)"
                  ></app-period-detail>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="17" class="text-center text-color-secondary p-3">Ninguna letra cumple el filtro.</td>
              </tr>
            </ng-template>
          </p-table>
          <!-- Fuera de <p-table>: como plantilla `summary` PrimeNG pinta su pie SIEMPRE, y sin nada
               que revelar dejaba una franja gris vacía bajo la tabla. -->
          <div class="enf-more" *ngIf="hiddenFutureCount">
            <button type="button" (click)="revealFuture()">Mostrar las {{ hiddenFutureCount }} letras futuras</button>
          </div>
        </div>
      </div>
    </div>

    <app-payment-drawer
      [(visible)]="showDrawer"
      [payment]="drawerPayment"
      [leaseId]="leaseDetailService.id"
      [activeLeases]="ledger.lease.client.activeLeases"
      (apply)="openApply([$event])"
      (adjust)="openAdjust($event)"
      (changeDate)="openChangeDate($event)"
      (cancelApplication)="openCancelApplication($event)"
    ></app-payment-drawer>

    <app-payment-date-dialog
      [(visible)]="showDateDialog"
      [payment]="datePayment"
      (saved)="ledgerService.refresh()"
    ></app-payment-date-dialog>

    <!-- Ajuste del pago: anular una carga repetida, cerrar un remanente o deshacer.
         El botón «Ajustar» del cajón emitía a nadie; este es su destino. -->
    <app-payment-adjust-modal
      #adjustModal
      [(visible)]="showAdjustModal"
      [payment]="adjustPayment"
      [group]="adjustGroup"
      [previewing]="adjustPreviewing"
      [saving]="adjustSaving"
      (onPreview)="previewAdjust($event, adjustModal)"
      (onApply)="applyAdjust($event, adjustModal)"
      (onLoadContext)="loadAdjustContext($event, adjustModal)"
    ></app-payment-adjust-modal>

    <app-apply-preview-dialog
      #previewDialog
      [clientLeases]="clientLeases"
      [(visible)]="showPreview"
      [mode]="previewMode"
      [payments]="previewPayments"
      [application]="previewApplication"
      [leaseId]="leaseDetailService.id"
      [nextToCollect]="ledger.nextToCollect"
      [nextToCollectDate]="nextToCollectDate"
      [previewing]="previewing"
      [saving]="savingPreview"
      (onPreview)="preview($event, previewDialog)"
      (onApply)="confirm($event, previewDialog)"
    ></app-apply-preview-dialog>

    <!-- Registrar un pago del cliente sin salir de la pestaña (F19), con el aviso de duplicado (F16) -->
    <p-dialog
      [(visible)]="showRegister"
      (onHide)="closeRegister()"
      [modal]="true"
      [closable]="false"
      [closeOnEscape]="false"
      [dismissableMask]="false"
      [draggable]="false"
      [resizable]="false"
      appendTo="body"
      [style]="{ width: '1200px', maxWidth: '96vw' }"
      header="Registrar pago"
      styleClass="p-fluid register-payment-dialog"
    >
      <ng-template pTemplate="content">
        <app-payment-form *ngIf="showRegister" [fixedClient]="fixedClient"></app-payment-form>

        <!-- Evidencia, no veredicto: se avisa y la persona decide (D11, U4) -->
        <div class="ap-warn is-blocking" *ngIf="duplicate">
          <i class="pi pi-exclamation-triangle"></i>
          <div>
            <strong>Ya existe un pago igual de este cliente en la ventana de duplicados</strong>
            <ul class="pdw-list">
              <li *ngFor="let t of duplicate.twins">
                <span class="pd-mono">{{ t.trackingKey }}</span> · {{ t.amount | currency }} · {{ t.date | date: 'dd/MM/yyyy' : 'UTC' }} ·
                {{ t.status }}<span *ngIf="t.leases?.length"> · {{ t.leases[0].folio }} letras {{ t.leases[0].letters.join(', ') }}</span>
              </li>
            </ul>
            <span
              >El cliente tiene {{ duplicate.activeLeases }} arrendamiento(s) activo(s): la misma renta en cada uno es un caso normal.</span
            >
            <div class="field mt-2">
              <label for="dupReason">Motivo para registrarlo de todos modos</label>
              <textarea id="dupReason" pInputTextarea [(ngModel)]="duplicateReason" rows="2" [maxlength]="500"></textarea>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <ng-container *ngIf="confirmingCloseRegister; else registerFooter">
          <span class="ap-discard-msg"><i class="pi pi-exclamation-triangle"></i> Se perderá lo capturado. ¿Cerrar de todos modos?</span>
          <button pButton type="button" label="Seguir aquí" class="p-button-text" (click)="confirmingCloseRegister = false"></button>
          <button pButton type="button" label="Sí, cerrar" icon="pi pi-times" class="p-button-danger" (click)="closeRegister()"></button>
        </ng-container>
        <ng-template #registerFooter>
          <button
            pButton
            type="button"
            label="Cancelar"
            icon="pi pi-times"
            class="p-button-text"
            (click)="requestCloseRegister()"
            [disabled]="savingPayment"
          ></button>
          <button
            *ngIf="!duplicate"
            pButton
            type="button"
            label="Guardar"
            icon="pi pi-check"
            (click)="savePayment()"
            [disabled]="!canSavePayment"
            [loading]="savingPayment"
          ></button>
          <button
            *ngIf="duplicate"
            pButton
            type="button"
            label="Registrar de todos modos"
            icon="pi pi-check"
            class="p-button-warning"
            (click)="savePayment(true)"
            [disabled]="!duplicateReason.trim() || savingPayment"
            [loading]="savingPayment"
          ></button>
        </ng-template>
      </ng-template>
    </p-dialog>

    <!-- Modal: editar fecha de inicio (cascada) -->
    <app-edit-start-date-modal
      [visible]="showEditModal"
      [currentFirstPeriodDate]="firstPeriodDate"
      [periodsCount]="data?.amortizationPeriods?.length || 0"
      [paidPeriodsCount]="paidPeriodsCount"
      [loading]="saving"
      (onHide)="showEditModal = false"
      (onSave)="saveStartDate($event)"
    >
    </app-edit-start-date-modal>

    <!-- Modal: editar saldos del arrendamiento (previsualización obligatoria antes de guardar) -->
    <app-edit-amounts-modal
      #amountsModal
      [(visible)]="showAmountsModal"
      [periods]="amountsPeriods"
      [totals]="amountsTotals"
      [leaseStatus]="leaseStatus"
      [interestRate]="data?.interestRate"
      [previewing]="previewingAmounts"
      [saving]="savingAmounts"
      [presetWaivePeriod]="presetWaivePeriod"
      (onHide)="showAmountsModal = false; presetWaivePeriod = null"
      (onPreview)="previewAmounts($event, amountsModal)"
      (onApply)="applyAmounts($event, amountsModal)"
    >
    </app-edit-amounts-modal>

    <!-- Modal: Refacturar factura -->
    <p-dialog
      [(visible)]="showRefacturarModal"
      [modal]="true"
      [dismissableMask]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '480px' }"
      header="Refacturar factura"
    >
      <div class="rf-modal-form">
        <div class="field">
          <label>Folio Fiscal actual</label>
          <input pInputText type="text" [value]="refacturarCurrentFolioFiscal" disabled />
        </div>
        <div class="field">
          <label for="rfNewFolio">Nuevo Folio Fiscal</label>
          <input
            id="rfNewFolio"
            pInputText
            type="text"
            [(ngModel)]="refacturarNewFolioFiscal"
            placeholder="Serie+Folio del nuevo CFDi (ej. A1198) — o adjunta su PDF/XML"
          />
          <small class="block mt-1 text-500"
            >Si adjuntas el PDF/XML abajo, el Folio Fiscal y el UID se leen del archivo; deja este campo vacío.</small
          >
        </div>
        <div class="field">
          <label for="rfReason">Motivo (opcional)</label>
          <textarea
            id="rfReason"
            pInputTextarea
            [(ngModel)]="refacturarReason"
            rows="2"
            [maxlength]="500"
            placeholder="Motivo de la refacturación"
          ></textarea>
        </div>
        <div class="field">
          <label>Archivos de la nueva factura (opcional; súbelos tal como se descargan, sin renombrar)</label>
          <div class="flex gap-2 flex-wrap">
            <label class="rf-mini-file"
              ><i class="pi pi-file-pdf"></i> {{ refacturarPdf?.name || 'Seleccionar PDF'
              }}<input type="file" accept=".pdf" hidden (change)="onRefacturarPdf($event)"
            /></label>
            <label class="rf-mini-file"
              ><i class="pi pi-file"></i> {{ refacturarXml?.name || 'Seleccionar XML'
              }}<input type="file" accept=".xml" hidden (change)="onRefacturarXml($event)"
            /></label>
          </div>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <button
          pButton
          type="button"
          label="Cancelar"
          class="p-button-text"
          (click)="showRefacturarModal = false"
          [disabled]="refacturando"
        ></button>
        <button
          pButton
          type="button"
          label="Refacturar"
          icon="pi pi-refresh"
          (click)="confirmRefacturar()"
          [disabled]="refacturando || (!refacturarNewFolioFiscal.trim() && !refacturarPdf && !refacturarXml)"
          [loading]="refacturando"
        ></button>
      </ng-template>
    </p-dialog>

    <!-- Modal: Cancelar factura -->
    <p-dialog
      [(visible)]="showCancelModal"
      [modal]="true"
      [dismissableMask]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '440px' }"
      header="Cancelar factura"
    >
      <div class="rf-modal-form">
        <div class="warn-box">
          <i class="pi pi-exclamation-triangle"></i>
          <span
            >La factura <strong>{{ cancelFolioFiscal || 'seleccionada' }}</strong> quedará cancelada. Se conserva el historial; el periodo
            quedará sin factura activa.</span
          >
        </div>
        <div class="field">
          <label for="cnReason">Motivo *</label>
          <textarea
            id="cnReason"
            pInputTextarea
            [(ngModel)]="cancelReason"
            rows="3"
            [maxlength]="500"
            placeholder="Motivo de la cancelación"
          ></textarea>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <button
          pButton
          type="button"
          label="Cerrar"
          class="p-button-text"
          (click)="showCancelModal = false"
          [disabled]="cancelando"
        ></button>
        <button
          pButton
          type="button"
          label="Confirmar cancelación"
          icon="pi pi-ban"
          class="p-button-danger"
          (click)="confirmCancel()"
          [disabled]="cancelando || !cancelReason.trim()"
          [loading]="cancelando"
        ></button>
      </ng-template>
    </p-dialog>

    <!-- Modal: Cargar factura del periodo (carga unitaria PDF/XML) -->
    <p-dialog
      [(visible)]="showUploadModal"
      [modal]="true"
      [dismissableMask]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '480px' }"
      header="Cargar factura del periodo"
    >
      <div class="rf-modal-form">
        <div class="warn-box rf-info-box">
          <i class="pi pi-info-circle"></i>
          <span
            >Periodo <strong>{{ uploadPeriod?.period }}</strong
            >. Sube el PDF y/o XML <strong>tal como se descargan</strong> del portal (no los renombres). Del XML se toman el UID, el monto y
            la fecha.</span
          >
        </div>
        <div class="field">
          <label>Archivos (PDF / XML)</label>
          <div class="flex gap-2 flex-wrap">
            <label class="rf-mini-file"
              ><i class="pi pi-file-pdf"></i> {{ uploadPdf?.name || 'Seleccionar PDF'
              }}<input type="file" accept=".pdf" hidden (change)="onUploadPdf($event)"
            /></label>
            <label class="rf-mini-file"
              ><i class="pi pi-file"></i> {{ uploadXml?.name || 'Seleccionar XML'
              }}<input type="file" accept=".xml" hidden (change)="onUploadXml($event)"
            /></label>
          </div>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <button
          pButton
          type="button"
          label="Cancelar"
          class="p-button-text"
          (click)="showUploadModal = false"
          [disabled]="uploadingInvoice"
        ></button>
        <button
          pButton
          type="button"
          label="Cargar"
          icon="pi pi-cloud-upload"
          (click)="confirmUpload()"
          [disabled]="uploadingInvoice || (!uploadPdf && !uploadXml)"
          [loading]="uploadingInvoice"
        ></button>
      </ng-template>
    </p-dialog>

    <!-- Modal: Historial de facturación del periodo -->
    <p-dialog
      [(visible)]="showHistoryModal"
      [modal]="true"
      [dismissableMask]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '640px' }"
      [header]="historyPeriodNumber ? 'Historial de facturación · Periodo ' + historyPeriodNumber : 'Historial de facturación'"
    >
      <div class="rf-history-list">
        <div class="rf-history-item" *ngFor="let inv of historyInvoices">
          <div class="rf-history-head">
            <span class="rf-history-folio">{{ inv.folioFiscal || '—' }}</span>
            <p-tag [value]="historyStatusLabel(inv.status)" [severity]="historyStatusSeverity(inv.status)"></p-tag>
            <span class="rf-history-amount">{{ inv.amount != null ? (inv.amount | currency) : '—' }}</span>
            <span class="rf-history-date">{{ inv.issueDate ? (inv.issueDate | date: 'dd/MM/yyyy') : '—' }}</span>
            <span class="rf-history-files">
              <button
                pButton
                type="button"
                pTooltip="Descargar PDF"
                tooltipPosition="top"
                class="p-button-text p-button-danger p-button-sm rf-file-btn"
                icon="fa-solid fa-file-pdf"
                [disabled]="!inv.pdfUrl || isDownloadingInvoice(inv, 'pdf')"
                (click)="downloadHistoryFile(inv, 'pdf')"
              ></button>
              <button
                pButton
                type="button"
                pTooltip="Descargar XML"
                tooltipPosition="top"
                class="p-button-text p-button-info p-button-sm rf-file-btn"
                icon="fa-solid fa-file-code"
                [disabled]="!inv.xmlUrl || isDownloadingInvoice(inv, 'xml')"
                (click)="downloadHistoryFile(inv, 'xml')"
              ></button>
            </span>
          </div>
          <div class="rf-history-reason" *ngIf="inv.cancelReason">
            <i class="pi pi-info-circle"></i> <strong>Motivo:</strong> {{ inv.cancelReason }}
          </div>
          <div class="rf-history-link" *ngIf="folioFiscalOf(inv.replaces)">
            Sustituye a <strong>{{ folioFiscalOf(inv.replaces) }}</strong>
          </div>
          <div class="rf-history-link" *ngIf="folioFiscalOf(inv.replacedBy)">
            Reemplazada por <strong>{{ folioFiscalOf(inv.replacedBy) }}</strong>
          </div>
        </div>
        <div *ngIf="!historyInvoices.length" class="text-color-secondary text-center p-3">Sin historial para este periodo.</div>
      </div>
      <ng-template pTemplate="footer">
        <button pButton type="button" label="Cerrar" class="p-button-text" (click)="showHistoryModal = false"></button>
      </ng-template>
    </p-dialog>

    <!-- Modal: Complementos de pago (REP) del periodo — reutiliza el componente del dashboard de facturas -->
    <app-invoice-complements-dialog [(visible)]="showComplementsModal" [invoice]="complementsInvoice" (changed)="onComplementsChanged()">
    </app-invoice-complements-dialog>
  </ng-container>
</div>
